module.exports = __webpack_public_path__ + "static/img/redbag-icon.4e9ead85.png";